export default "__VITE_ASSET__aURHoBn2__"